<template>
    <div class="left-job-warp" v-loading="loading">
        <div class="pt10 pb10 pl10 pr10 flex-box al-c">
            <div class="bold font-16" style="color: #666;">全部岗位</div>
            <el-button size="mini" type="primary" style="margin-left: auto" @click="handleAdd">新建岗位</el-button>
        </div>
        <ul  v-if="list.length&&!loading">
            <li v-for="item in list"
                :class="{'selected':item.postId==curItem}"
                class="cl-f"
                >
                <div class="left" @click="switchItemFn(item)">
                    {{item.postName}}
                </div>
                <div class="right">
                    <i class="el-icon-edit" @click="openDetailFn(item)"></i>
                    <i class="el-icon-delete"  @click="handleDelFn(item.postId)"></i>
                </div>
            </li>
        </ul>
        <div v-if="list.length==0&&!loading" class="no-data">未查询到岗位</div>
    </div>
</template>

<script>
    import { getAllJobList,handleDelJob} from '@/api/managementCenter/jobManage';
    export default {
        name: "leftJobList",
        data(){
            return{
                loading:false,
                keywords:'',
                curItem:'',
                list:[]
            }
        },
        mounted(){
            this.getJobListFn();
        },
        methods:{
            handleAdd(){
                this.$emit('handleAdd')

            },
            getJobListFn(){
                this.loading=true;
                getAllJobList().then(({data}) => {
                    this.loading=false;
                        if(data.code == 0){
                            this.list=data.data||[];
                            if(this.list.length){
                                this.switchItemFn(this.list[0]);
                            }else{
                                this.switchItemFn({});
                            }
                        }else{
                            this.$message.warning( data.msg||"获取岗位失败！" );
                        }
                    }).catch(err=>{
                        this.loading=false;
                    })
            },
            switchItemFn(item){
                this.curItem=item.postId;
                this.$emit('selectJob',item)
            },
            openDetailFn(item){
                this.$emit('openDetailFn',item)
            },
            // 删除
            handleDelFn(id){
                this.$confirm( "是否确定删除?", "提示", {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.deleteHttp(id)

                }).catch(() => {
                    this.$message.info( "已取消删除" );

                });
            },
            deleteHttp(id){
                this.loading = true;
                // 删除接口
                handleDelJob(id).then( ({data}) => {
                    this.loading = false;
                    if(data.code == 0){
                        this.$message.success("删除成功!" );
                        this.getJobListFn();
                    }else{
                        this.$message.warning( data.msg||"删除失败！" );
                    }
                }).catch(() => {
                    this.loading = false;
                    this.$message.error( "删除异常!" );
                });
            },
        }
    }
</script>

<style scoped lang="less">
    .left-job-warp{
        >ul{
            padding-top: 10px;
            height: calc(100vh - 230px);
            overflow-y: auto;
            >li{
                color: #666;
                padding:0 10px;
                height: 40px;
                line-height: 40px;
                font-weight: bold;
                font-size: 13px;
                border-bottom: 1px dashed #F1F3F4;
                cursor: pointer;
                width: 100%;
                box-sizing: border-box;

                &:hover{
                    background: rgba(241, 243, 244,0.5);
                    color: #000000;
                    font-size: 14px;
                }
                &.selected{
                    background: #F3F3F3;
                    color: #666666;
                    font-size: 13px;
                    border-bottom: 1px solid #FFFFFF;
                    i{
                        color: #666666!important;
                        &:hover{
                            font-size: 14px;
                        }
                    }
                }
                .left{
                    float: left;
                    width: calc(100% - 42px);
                    overflow: hidden;
                    text-overflow:ellipsis;
                    white-space: nowrap;
                    i{
                        color: #55C2FD;
                    }
                }
                .right{
                    width:40px;
                    float: right;
                    text-align: right;
                    i{
                        &.el-icon-delete{
                            margin-left: 5px;
                        }
                        color: #ccc;
                        &:hover{
                            color: #666666;
                        }
                    }
                }
            }
        }

    }
</style>
